import { render, staticRenderFns } from "./PackItem.vue?vue&type=template&id=c8b676d6"
import script from "./PackItem.vue?vue&type=script&lang=js"
export * from "./PackItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports